import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { mapActions, mapGetters } from 'vuex'
import * as accountTypes from '@account/store/types';
import * as types from '@reserve/store/types'
import { EnumCalendarViewType } from '@reserve/types'
import { IEDate, uGetDateFormat } from '@/modules/@appbase/util';

import api from '@reserve/api'
import { getResourceColor } from '@reserve/store/consts'
import TimeLine from './TimeLine.vue'
import GridView from '@appbase/components/GridView/GridView.vue';
import * as popupHelper from '@appbase/util/popup-helper';
import modalHelper from '@appbase/util/modal-helper';
import ResourceInformationModal from '../ResourceInformationModal.vue';
import { openReserveWindow } from '../../popup-handler'
import PageNavigationBar from '@appbase/components/Paginate/PageNavigationBar.vue'

@Component({
    components: { TimeLine, GridView, PageNavigationBar },
    computed: mapGetters({
        current: accountTypes.CURRENT,
        isLoading: types.CALENDAR_LOADING,
        currentDate: types.CALENDAR_DATE_CURRENT,
        lastRefresh: types.CALENDAR_LAST_REFRESH,
        selectedResources: types.SELECTED_RESOURCE_LIST,
        rightPaneOpen: types.CALENDAR_RIGHTPANE_OPEN
    }),
    methods: {
        ...mapActions({
        setViewMode: types.CALENDAR_VIEWMODE,
        selectDate: types.CALENDAR_DATE_SELECTRELOAD,
        cancelDbEvent: types.CALENDAR_EVENT_DBCANCEL,
        toggleRightPane: types.CALENDAR_TOGGLE_RIGHTPANE,
        })
    }
})
export default class TotalView  extends Vue {
    setViewMode!: (viewType: EnumCalendarViewType) => void;
    selectDate!: (dateItem: reserve.DateItem) => Promise<any>;
    cancelDbEvent!: (payload: {item: reserve.CalendarItem}) => Promise<any>;
    toggleRightPane!: (payload: boolean) => void;
    
    current!: account.TCurrent;
    isLoading!: boolean;
    currentDate!: reserve.DateItem;
    lastRefresh!: number | null;
    selectedResources!: reserve.ResourceItemBase[];
    rightPaneOpen!: boolean;

    resourceList: reserve.DbResourceItem[] = [];
    displayTooltip: string = '';

    resourceHeader: gridView.Header[] = [
        // 아래 '항목'의 rowKey를 displayName에서 etc1으로 변경한다. etc1은 '항목명 (항목의 설명)'이 들어있는 형태이다.
        { displayName: this.$t('항목').toString(), rowKey: 'etc1' },
        { displayName: '', rowKey: '', width: '80px', slotName: 'reservation' },
        { displayName: '', rowKey: '', width: '80px', slotName: 'information' },
    ]

    reservationHeader: gridView.Header[] = [
        { displayName: this.$t('자산').toString(), rowKey: 'location' },
        { displayName: this.$t('이름').toString(), rowKey: 'organizerName', width: '200px', align: 'center' },
        { displayName: this.$t('예약시간').toString(), rowKey: '', width: '380px', align: 'center', slotName: 'reservationDate' },
        { displayName: this.$t('취소').toString(), rowKey: '', width: '100px', align: 'center', slotName: 'cancel' },
    ]

    myReserveList: reserve.CalendarItem[] = []
    page: number = 1
    perPage: number = 10
    total: number = 0

    @Watch('lastRefresh')
    onChangedRefresh(refresh: number){
        this.loadResourceItems()
    }

    @Watch('isLoading')
    onChangedLoading(loading: boolean){
        if(!loading){
            this.loadResourceItems();
            this.getMyReservation();
        }
    }

    get SelectResource(){
        var ids = this.selectedResources.map(s=>s.uniqueId)
        return ids.length>0? this.resourceList.filter(r=> ids.includes(r.uniqueId)) : []
    }

    get IsToday(){
        return uGetDateFormat('yyyy-MM-dd',IEDate(this.currentDate.date)) == uGetDateFormat('yyyy-MM-dd', new Date());
    }

    get DateString(){
        return uGetDateFormat('yyyy.MM.dd', IEDate(this.currentDate.date))
    }

    convertDateFormat(date: string){
        return uGetDateFormat('yyyy-MM-dd H:i', new Date(date))
    }

    goSelect(move: number) {
        if(this.isLoading)
            return;

        var nextItem: reserve.DateItem = {
            ...this.currentDate
        }
        nextItem.date.setDate(nextItem.date.getDate()+move);
        this.selectDate(nextItem);
    }

    loadResourceItems(){
        api.resource.getResources(this.current.user.comCode, 'DB').then(res=>{
            this.resourceList = res.map(r=>{
                return {
                    ...r,
                    selected: false,
                    colorCode: getResourceColor(r.uniqueId),
                    childItems: []
                }
            })
        })
    }

    onInformationClick(uniqueId: string) {
        if(this.isTeams) {
            modalHelper.show({
                component: ResourceInformationModal,
                value: uniqueId        
            })
        } else {
            popupHelper.openPopup(`resourceInfo_${uniqueId}`, "/reservePopup/info",
            {
                uniqueId: uniqueId
            },
            {
                width: 620,
                height: 700,               
            })         
        }     
    }

    async onCancelClick(evt: reserve.CalendarItem){
        if(await (window as any).confirmAsync(this.$t('예약삭제_확인').toString())){
            this.cancelDbEvent({item:evt}).then(async res=>{
                await (window as any).alertAsync(this.$t('예약삭제_안내').toString());
            }).finally(()=>{
                this.getMyReservation()
            })
        }
    }

    onReservationClick(uniqueId: string){
        openReserveWindow({
            comCode: this.current.user.comCode,
            category: 'DB',
            resource: uniqueId
        });  
    }

    pageMove(num:number){
        this.page = num
        this.getMyReservation()
    }

    getReservationStatus(uniqueId: string){
        var result = false;
        var ref = this.$refs[uniqueId]
        if(ref){
            result = (ref as any)[0].getReservationStatus()
        }
        return result;
    }

    getMyReservation(){
        api.resourceDb.getUserReservationList(this.page, this.perPage).then(res=>{
            this.page = res.currentPage;
            this.total = res.totalCount;
            this.myReserveList = res.data;
        })
    }

    created() {
        if(this.rightPaneOpen){
            this.toggleRightPane(false);
        }
        this.setViewMode(EnumCalendarViewType.Total);
        this.loadResourceItems();
        this.getMyReservation();
    }
}